// Importing utilities
import { parseDate } from 'utils/date';

const valiDateOptionalFormField = (value) => {

    if (value?.length > 0 && value !== undefined && value !== null) return true;

};

const isNull = (value) => {

    if (value === null) return true;

};

const isFile = (value) => {

    return value instanceof File;

};

const isReadOnly = (permissions) => {
    return ( permissions.length === 1 ) && permissions.includes('read');
};

function parseUserData(employeeData) {

    const {
        biometricDetails,
        bankDetails = {},
        dateOfJoining,
        dateOfBirth,
        address,
        shift,
        designation,
        team,
        role,
        recordingFrequency,
        recordingMode,
        lastModified,
        ...restEmployeeData } = employeeData;


    let formatDateOfJoining = "", formatDateOfBirth = "";

    // Dates are now in ISO format (YYYY-MM-DD) from the server
    // Parse them to yyyy-MM-dd format for form inputs
    if (dateOfJoining) {
        formatDateOfJoining = parseDate('yyyy-MM-dd', dateOfJoining);
    }

    if (dateOfBirth) {
        formatDateOfBirth = parseDate('yyyy-MM-dd', dateOfBirth);
    }

    const formatUserData = {
        ...restEmployeeData,
        dateOfJoining: formatDateOfJoining,
        dateOfBirth: formatDateOfBirth,
        address: address || "",
        shift: shift.id,
        designation: designation.id,
        team: team.id,
        role: role.id,
        profilePicture: biometricDetails.profilePicture,
        bankName: bankDetails.bankName || "",
        accountNumber: bankDetails.accountNumber || "",
        ifscCode: bankDetails.ifscCode || "",
        recordingFrequency: recordingFrequency ?? "",
        recordingMode: recordingMode || "interval",
        password: "",
    };

    return formatUserData;

};

export {
    valiDateOptionalFormField,
    isNull,
    isFile,
    isReadOnly,
    parseUserData,
};